<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">
          <span class="arch">
            <p>I can see the tide rise. I can anticipate each ebb and flow of water into brick and stone, an erosion that creeps towards time gone. Here it's visible as temporal gradients. Strata and stricture. </p>
           <br>
 <p>I remember fragments from before, little slivers of memory slipped between the fog in my mind. They sting, cut and burrow and grate like sand when my attention passes toward them, working them lose. </p>
           <br>
 <p>Only one moment.</p>
           <br>
 <p>We walked here, marking streets and noting the instances for a child yet to be born. Then nothing, a grey zone over memories and suddenly clarity once more. </p>
           <br>
 <p>A woman's laughter. A rush of water and a sluice gate opened, sending waterfowl into the air above a square in the sunlight. A cold light, early morning, the smell of coffee and baking bread. The cries of birds, screaming into the sky and.</p>
           <br>
 <p>And nothing. </p>
           <br>
 <p>A grey mist, threads of narrative that cannot be grasped for long. I imagine each one unfolding away from me as I reach for them, each strand slipping through my fingers. </p>
           <br>
 <p>And then I am back here, the ground again sure beneath my feet, the sound of water flowing nearby. Here in this city, alone, I find it hard to choose what to write, what to remember.</p>
           <br>
 <p>Sometimes, I think, I need new eyes to see this world. </p>
            <p></p>
           <br>
 <p>I cut a hole in the paper of the book, I hold it in front of my face and look out across the city, the page as a camera, a frame to focus through. </p>
            <br>
<p>I turn slowly, scanning the horizon, paying attention to each building, each person, each road that enters the frame, and the ones that feel important, the things I want to tell her about, I write them down below the frame, fixing them in words</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </span>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'I Can See The Tides Rise'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
